function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import regeneratorRuntime from "regenerator-runtime";
import { raiseSfError } from "./utils";
import { flattenDeep, flatten, merge } from "lodash";
import { context } from "../../components/wr-context";
import { mergeRowsValues } from "../product";
import { getProductRow, RowVariants } from "../../utils/product/get-product-row";
import { customRandom, urlAlphabet, random } from "nanoid";
import safeJsonParse from "../../utils/safe-json-parse";
var nanoid = customRandom(urlAlphabet, 10, random);
var selectItemReferenceKey = function(item) {
    var ref;
    return ((ref = getProductRow(item, RowVariants.Tag, "sku_id")) === null || ref === void 0 ? void 0 : ref.control) || "";
};
export var getCartId = function() {
    return nanoid();
};
var makeRef = function(id) {
    return "ref_".concat(id);
};
// Really don't want to have any collisions here
var makeRandomRef = function() {
    return makeRef("random_".concat(nanoid()));
};
var makeQuoteLine = function(quoteLine) {
    return {
        url: "/services/data/v50.0/sobjects/SBQQ__QuoteLine__c/",
        body: _objectSpread({
            SBQQ__Quantity__c: quoteLine.quantity,
            SBQQ__Product__c: quoteLine.productId,
            SBQQ__Group__c: quoteLine.groupId,
            SBQQ__Quote__c: quoteLine.quoteId,
            SBQQ__ProductOption__c: quoteLine.productOptionId
        }, quoteLine.pricingDimension, Boolean(quoteLine.bundled) && {
            SBQQ__Bundled__c: true
        }, Boolean(quoteLine.requiredBy) && {
            SBQQ__RequiredBy__c: "@{".concat(quoteLine.requiredBy, ".id}")
        }),
        method: "POST",
        referenceId: quoteLine.referenceId || makeRandomRef()
    };
};
/**
 * Checks for existing quote line groups. If such exist, then their child
 * quotes are deleted.
 */ export var upsertQuoteLineGroups = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(groupLabels, quoteId, accountId) {
        var sfConn, createdQuoteLineGroups, existingQuoteLineGroups, quoteLineGroups;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    sfConn = context.constants.getSfConn();
                    createdQuoteLineGroups = {};
                    _ctx.next = 4;
                    return sfConn.sobject("SBQQ__Quote__c").update({
                        Id: quoteId,
                        SBQQ__LineItemsGrouped__c: true
                    });
                case 4:
                    _ctx.next = 6;
                    return sfConn.sobject("SBQQ__QuoteLineGroup__c").find({
                        Name: {
                            $in: groupLabels
                        },
                        SBQQ__Quote__c: quoteId
                    }, [
                        "Id",
                        "Name"
                    ]);
                case 6:
                    existingQuoteLineGroups = _ctx.sent;
                    if (!(existingQuoteLineGroups && existingQuoteLineGroups.length && groupLabels.every(function(groupName) {
                        return existingQuoteLineGroups.some(function(quoteLineGroup) {
                            return quoteLineGroup.Name === groupName;
                        });
                    }))) {
                        _ctx.next = 13;
                        break;
                    }
                    _ctx.next = 10;
                    return sfConn.sobject("SBQQ__QuoteLine__c").find({
                        SBQQ__Group__c: {
                            $in: existingQuoteLineGroups.map(function(quoteLineGroup) {
                                return quoteLineGroup.Id;
                            })
                        },
                        SBQQ__Quote__c: quoteId
                    }, [
                        "Id",
                        "SBQQ__Group__c"
                    ]).destroy();
                case 10:
                    createdQuoteLineGroups = merge({}, existingQuoteLineGroups.map(function(quoteLineGroup) {
                        return _defineProperty({}, quoteLineGroup.Name, quoteLineGroup.Id);
                    }));
                    _ctx.next = 17;
                    break;
                case 13:
                    quoteLineGroups = groupLabels.map(function(label, i) {
                        return {
                            SBQQ__Quote__c: quoteId,
                            SBQQ__Account__c: accountId,
                            SBQQ__Number__c: i + 1,
                            Name: label
                        };
                    }).filter(Boolean);
                    _ctx.next = 16;
                    return raiseSfError(sfConn.sobject("SBQQ__QuoteLineGroup__c").create(quoteLineGroups, {
                        allOrNone: true
                    })).then(function(records) {
                        return merge({}, records.map(function(quoteLineGroup, i) {
                            return _defineProperty({}, quoteLineGroups[i].Name, quoteLineGroup.Id);
                        }));
                    });
                case 16:
                    createdQuoteLineGroups = _ctx.sent;
                case 17:
                    return _ctx.abrupt("return", createdQuoteLineGroups // { [Name]: Id pairs }
                    );
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function upsertQuoteLineGroups(groupLabels, quoteId, accountId) {
        return _ref.apply(this, arguments);
    };
}();
export var createQuoteLines = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(quoteLineGroups, quoteId, accountId) {
        var _state, phasesConfig, cart, sfConn, phaseItems, itemsGrouped, createdQuoteLineGroups, quoteLines, ourProductIds, sfProducts, missingIds, payload;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _state = context.state, phasesConfig = _state.phasesConfig, cart = _state.cart;
                    sfConn = context.constants.getSfConn();
                    phaseItems = cart.filter(function(item) {
                        return item.hasOwnProperty("phase") || item.hasOwnProperty("phasesBreakdown");
                    });
                    itemsGrouped = quoteLineGroups || {
                        ungrouped: phaseItems
                    };
                    ;
                    if (!quoteLineGroups) {
                        _ctx.next = 11;
                        break;
                    }
                    _ctx.next = 8;
                    return upsertQuoteLineGroups(Object.keys(itemsGrouped).filter(function(k) {
                        return k !== "Questionnaire" && itemsGrouped[k].length;
                    }), quoteId, accountId);
                case 8:
                    createdQuoteLineGroups = _ctx.sent;
                    _ctx.next = 12;
                    break;
                case 11:
                    {
                        createdQuoteLineGroups = {
                            ungrouped: undefined
                        };
                    }
                case 12:
                    _ctx.t0 = flatten;
                    _ctx.next = 15;
                    return Promise.all(Object.keys(itemsGrouped).map(function(groupLabel) {
                        var items = itemsGrouped[groupLabel];
                        if (!items || !items.length) {
                            return false;
                        }
                        return Promise.all(items.map(function() {
                            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_item) {
                                var ref, item, referenceKey, quantityRow, productQuantity, selectedOptions, productConfig, pricingDimension;
                                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            ;
                                            item = mergeRowsValues(_item.values, _item);
                                            referenceKey = selectItemReferenceKey(item);
                                            quantityRow = getProductRow(item, RowVariants.Tag, "quantity");
                                            productQuantity = quantityRow ? item.values[quantityRow.id + "_" + ((ref = quantityRow === null || quantityRow === void 0 ? void 0 : quantityRow.options.items) === null || ref === void 0 ? void 0 : ref[0].id) + "_notes"] : 1;
                                            selectedOptions = flattenDeep(phasesConfig === null || phasesConfig === void 0 ? void 0 : phasesConfig.itemGroups.map(function(param) {
                                                var itemRows = param.itemRows;
                                                return itemRows;
                                            }).filter(Boolean)).map(function(param) {
                                                var phasesBreakdown = param.phasesBreakdown;
                                                var data = phasesBreakdown.data, roles = phasesBreakdown.roles;
                                                // Aggregate role quantities and turn them into [label, quantity] pairs
                                                return roles.map(function(param, i) {
                                                    var label = param.label;
                                                    var values = data[i];
                                                    var acc = values.reduce(function(acc, v) {
                                                        return Number(v) + Number(acc);
                                                    }, 0);
                                                    return [
                                                        label,
                                                        acc
                                                    ];
                                                });
                                            });
                                            _ctx.next = 8;
                                            return resolveProductConfiguration(referenceKey, selectedOptions, quoteId);
                                        case 8:
                                            productConfig = _ctx.sent;
                                            pricingDimension = {};
                                            return _ctx.abrupt("return", [
                                                makeQuoteLine({
                                                    quantity: productQuantity,
                                                    productId: referenceKey,
                                                    groupId: createdQuoteLineGroups[groupLabel],
                                                    quoteId: quoteId,
                                                    productOptionId: "",
                                                    referenceId: makeRef(referenceKey),
                                                    pricingDimension: pricingDimension
                                                }), 
                                            ].concat(_toConsumableArray(mapConfigToQuoteLines(productConfig, createdQuoteLineGroups[groupLabel], productQuantity || 1, quoteId))));
                                        case 11:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(_item) {
                                return _ref.apply(this, arguments);
                            };
                        }()));
                    }).filter(Boolean));
                case 15:
                    _ctx.t1 = _ctx.sent;
                    quoteLines = (0, _ctx.t0)(_ctx.t1);
                    if (!quoteLines.length) {
                        _ctx.next = 25;
                        break;
                    }
                    ourProductIds = flatten(quoteLines).map(function(ql) {
                        return ql.SBQQ__Product__c;
                    }).filter(function(d) {
                        return d;
                    });
                    _ctx.next = 21;
                    return raiseSfError(sfConn.sobject("Product2").find({
                        Id: ourProductIds
                    }).select("Id, Name"));
                case 21:
                    sfProducts = _ctx.sent;
                    missingIds = ourProductIds.filter(function(ourId) {
                        return !sfProducts.find(function(sfp) {
                            return sfp.Id === ourId;
                        });
                    });
                    if (!missingIds.length) {
                        _ctx.next = 25;
                        break;
                    }
                    throw new Error("Invalid SKU IDs found while creating quote lines: ".concat(missingIds.join(", ")));
                case 25:
                    payload = {
                        graphs: quoteLines.map(function(quoteLine, i) {
                            return {
                                graphId: i.toString(),
                                compositeRequest: quoteLine
                            };
                        })
                    };
                    _ctx.next = 28;
                    return raiseSfError(sfConn.requestPost("/services/data/v50.0/composite/graph", payload));
                case 28:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function createQuoteLines(quoteLineGroups, quoteId, accountId) {
        return _ref.apply(this, arguments);
    };
}();
function resolveProductConfiguration(productId, selectedOptions, quoteId) {
    return _resolveProductConfiguration.apply(this, arguments);
}
function _resolveProductConfiguration() {
    _resolveProductConfiguration = _asyncToGenerator(regeneratorRuntime.mark(function _callee(productId, selectedOptions, quoteId) {
        var sfConn, quote, productConfiguration, productRef, generatedConfig, optionalConfig;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    sfConn = context.constants.getSfConn();
                    _ctx.t0 = safeJsonParse;
                    _ctx.next = 4;
                    return sfConn.apex.get("/SBQQ/ServiceRouter?reader=SBQQ.QuoteAPI.QuoteReader&uid=".concat(quoteId));
                case 4:
                    _ctx.t1 = _ctx.sent;
                    quote = (0, _ctx.t0)(_ctx.t1);
                    _ctx.t2 = safeJsonParse;
                    _ctx.next = 9;
                    return sfConn.apex.patch("/SBQQ/ServiceRouter?loader=SBQQ.ConfigAPI.ConfigLoader&uid=".concat(productId), {
                        context: JSON.stringify({
                            quote: quote
                        })
                    });
                case 9:
                    _ctx.t3 = _ctx.sent;
                    productConfiguration = (0, _ctx.t2)(_ctx.t3);
                    productRef = makeRef(productId);
                    generatedConfig = generateProductConfiguration(productConfiguration.configuration, productRef);
                    optionalConfig = [];
                    _ctx.prev = 14;
                    optionalConfig = generateProductOptionalConfiguration(productConfiguration.options, selectedOptions, productRef);
                    _ctx.next = 22;
                    break;
                case 18:
                    _ctx.prev = 18;
                    _ctx.t4 = _ctx["catch"](14);
                    if (!(_ctx.t4 === null || _ctx.t4 === void 0 ? void 0 : _ctx.t4.message)) {
                        _ctx.next = 22;
                        break;
                    }
                    throw new Error("".concat(_ctx.t4.message, ' in product "').concat(productConfiguration.record.Name, '"'));
                case 22:
                    return _ctx.abrupt("return", _toConsumableArray(generatedConfig).concat(_toConsumableArray(optionalConfig)));
                case 23:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                14,
                18
            ]
        ]);
    }));
    return _resolveProductConfiguration.apply(this, arguments);
}
var generateProductOptionalConfiguration = function(options) {
    var selectedOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], parentRef = arguments.length > 2 ? arguments[2] : void 0;
    return flatten(selectedOptions).map(function(param) {
        var _param = _slicedToArray(param, 2), k = _param[0], quantity = _param[1];
        // TODO: Throw up error if this mapping does not exist
        var skuIdMap = context.constants.sfMaps.skuRoleMap;
        var sku = skuIdMap[k];
        if (!sku) {
            throw new Error('SKU ID for "'.concat(k, '" missing in "Sku IDs" data table'));
        }
        var option = options.find(function(v) {
            return v.record.SBQQ__OptionalSKU__c === sku;
        });
        if (!option || !option.record) {
            throw new Error('Product option for role "'.concat(k, '" missing'));
        }
        /*
       * NOTE
       * We're not assigning referenceId to these since the current assumption
       * is that they are the last tier of dependencies and nothing else is
       * requiredBy them. If this assumption changes, consider also generating
       * multiple composite graph groups to avoid referenceId collisions.
       */ return {
            optionData: _objectSpreadProps(_objectSpread({}, option.record), {
                SBQQ__OptionalSKU__c: sku,
                SBQQ__Quantity__c: quantity
            }),
            requiredBy: parentRef
        };
    }).filter(Boolean);
};
function generateProductConfiguration(opt, parentRef) {
    if (!opt) {
        return [];
    }
    var opts = opt.optionConfigurations;
    var referenceId = opt.optionId ? makeRef(opt.optionId) : parentRef;
    return _toConsumableArray(opt.optionData.hasOwnProperty("Id") ? [
        _objectSpreadProps(_objectSpread({}, opt), {
            requiredBy: parentRef,
            referenceId: referenceId
        }), 
    ] : []).concat(_toConsumableArray(opts.map(function(v) {
        return generateProductConfiguration(v, referenceId);
    }).reduce(function(acc, v) {
        return acc.concat(v);
    }, [])));
}
var mapConfigToQuoteLines = function(conf, groupId, baseQuantity, quoteId) {
    return conf.map(function(v) {
        return makeQuoteLine({
            quantity: v.optionData.SBQQ__Quantity__c * baseQuantity,
            productId: v.optionData.SBQQ__OptionalSKU__c,
            bundled: v.optionData.SBQQ__Bundled__c,
            groupId: groupId,
            quoteId: quoteId,
            productOptionId: v.optionData.Id,
            requiredBy: v.requiredBy,
            referenceId: v.referenceId,
            pricingDimension: {}
        });
    });
};
export default createQuoteLines;
